import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'ancillaries_hub';
export const route = 'ancillaries_hub/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/AncillaryHubPage')));